import { useQuery } from "@tanstack/react-query";
import { useServices } from "@/services/ServiceProvider";

/**
 * A member's off-chain track record by profile id (`get_profile_track_record`).
 * Keyed by id, not handle: handles can change, and a handle-keyed cache could
 * pair one member's header with another's record. `data === null` means the
 * profile doesn't exist; an error is a failed read and must render as one —
 * never as an empty record.
 *
 * `handle` (the /u/:handle page only) routes the read through the door a
 * logged-out visitor may use; the record and its cache key stay the id's.
 */
export function useTrackRecord(profileId: string | null | undefined, handle?: string) {
  const { users } = useServices();
  return useQuery({
    queryKey: ["track-record", profileId],
    queryFn: () =>
      handle ? users.getTrackRecordForHandle(handle, profileId!) : users.getTrackRecord(profileId!),
    enabled: !!profileId,
    // Only moves when a submission is approved or a quest launches.
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
    retry: 1,
  });
}
